import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { getAstroNovaPreSaleV2Contract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const CurrentRoundAstroNovaV2 = () => {
  const [balance, setBalance] = useState(null);
  // const { account } = useWeb3React();
  const web3 = useWeb3();

  const AstraNovaAddressV2 = Environment.AstroNovaPreSaleV2;

  const AstraNovaContractClaimsV2 = getAstroNovaPreSaleV2Contract(
    AstraNovaAddressV2,
    web3
  );

  const project = localStorage.getItem("project");
  const currentRoundAstraNovaV2 = useCallback(async () => {
    if (project == "ASTRANOVA") {
      try {
        const buy = await AstraNovaContractClaimsV2.methods
          .getRoundCount()
          .call();
        return buy;
      } catch (error) {
        console.log("dlsflasdfjlasdf", error);
        throw error;
      }
    }
  }, [AstraNovaContractClaimsV2, web3]);
  return { currentRoundAstraNovaV2: currentRoundAstraNovaV2 };
};
export default CurrentRoundAstroNovaV2;
